"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const arrays_1 = require("../../type-checking/arrays");
class LinkFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, arrays_1.isArrayOfStringsValue)(fieldValue);
        };
        this.getEmptyValue = () => [];
    }
}
exports.LinkFieldValueGetter = LinkFieldValueGetter;
